import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { fetchHomeContent } from '../../services/homeContentApi';


const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 1,
  loop: true,
  effect: 'fade',
  pagination: {
    el: '#main-slider-pagination',
    type: 'bullets',
    clickable: true
  },
  navigation: {
    nextEl: '#main-slider__swiper-button-next',
    prevEl: '#main-slider__swiper-button-prev'
  },
  autoplay: {
    delay: 8000
  }
}

export default function Banner() {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const content = await fetchHomeContent();
        if (cancelled) return;
        setSlides(Array.isArray(content?.banners) ? content.banners : []);
      } catch {
        if (!cancelled) setSlides([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const computedSlides = useMemo(() => {
    const active = (slides || []).filter((s) => s?.image);
    if (active.length > 0) return active;
    return [
      {
        image: '/images/events/mulema_6.jpg',
        subtitle: 'Singing competition',
        title: 'Season 2',
        titleAccent: 'Mulema Gospel Talent',
        description:
          'Mulema Gospel Talent is delighted to announce a partnership between Trace Gospel and for the year 2026.',
        location: 'Yaounde, Cameroun',
        timeLabel: '2026',
        ctaText: 'Registration',
        ctaLink: 'https://mulemagc.com',
      },
    ];
  }, [slides]);

  return (
    <>
      {/* banner-one */}
      <section id='th-home' className="main-slider">
        <Swiper {...swiperOptions} className="swiper-container thm-swiper__slider">
          <div className="swiper-wrapper">

            {/* <SwiperSlide className="swiper-slide">
              <div className="main-slider__img">
                <img src={'images/events/mulema_1.jpg'} alt="" />
              </div>

              <div className="container">
                <div className="row row-mboa">
                  <div className="col-xl-12">
                    <div className="main-slider__content">
                      <p className="main-slider__sub-title">Concours de Chant</p>
                      <h2 className="main-slider__title">
                        Saison 2 <br /> <span>Mulema Gospel Talent</span>
                      </h2>
                      <p className="main-slider__text">
                        Après une première saison riche en émotions et en révélations, l’histoire continue.
                        La Saison 2 de Mulema Gospel Talent est officiellement lancée.
                        De nouvelles voix, de nouveaux parcours, une nouvelle grâce.
                        <br />👉 Les inscriptions sont ouvertes.
                        Pour faire partie de cette nouvelle édition, inscrivez-vous dès maintenant sur
                        <br />🌐 https://mulemagc.com
                        Plus d’informations ce soir à 18h sur toutes les plateformes de Mulema Gospel ☺️
                      </p>
                      <ul className="list-unstyled main-slider__address">
                        <li>
                          <div className="icon">
                            <span className="icon-pin"></span>
                          </div>
                          <div className="text">
                            <p>Yaoundé, Cameroun</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="icon-clock"></span>
                          </div>
                          <div className="text">
                            <p>2026</p>
                          </div>
                        </li>
                      </ul>
                      <div className="main-slider__btn-box">
                        <Link to="https://mulemagc.com" className="main-slider__btn thm-btn">
                          Inscription
                          <span className="icon-arrow-right"></span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide className="swiper-slide">
              <div className="main-slider__img">
                <img src={'images/events/praisetime.jpg'} alt="" />
              </div>

              <div className="container">
                <div className="row row-mboa">
                  <div className="col-xl-12">
                    <div className="main-slider__content">
                      <p className="main-slider__sub-title">Concerts</p>
                      <h2 className="main-slider__title">
                        Acte 5 <br /> <span>Praise Time</span>
                      </h2>
                      <p className="main-slider__text">
                        Praise Time, Acte 5
                        📍 14 février 2026 | Palais des Congrès de Yaoundé dès 14h

                        Une date. Un lieu. Une atmosphère qui s’annonce intense avec des ministres prêts à marquer les cœurs : l’humoriste Cabrel Tindo, le Psalmist Joël Fa et la chantre Grâce Béthel ❤️

                        📌 Un moment particulier avec l’artiste David Okit Officiel pour sa toute première participation au Cameroun.

                        L’entrée est totalement GRATUITE, mais sous inscription.
                      </p>
                      <ul className="list-unstyled main-slider__address">
                        <li>
                          <div className="icon">
                            <span className="icon-pin"></span>
                          </div>
                          <div className="text">
                            <p>Palais des Congrès de Yaoundé</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="icon-clock"></span>
                          </div>
                          <div className="text">
                            <p>14 février 2026 à 14h</p>
                          </div>
                        </li>
                      </ul>
                      <div className="main-slider__btn-box">
                        <Link to="https://mulemagc.com" className="main-slider__btn thm-btn">
                          Inscription
                          <span className="icon-arrow-right"></span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide> */}

            {computedSlides.map((slide, idx) => (
            <SwiperSlide className="swiper-slide" key={idx}>
              <div className="main-slider__img">
                <img src={slide.image} alt={slide.title || `slide-${idx + 1}`} />
              </div>

              <div className="container">
                <div className="row row-mboa">
                  <div className="col-xl-12">
                    <div className="main-slider__content">
                      <p className="main-slider__sub-title">{slide.subtitle || ''}</p>
                      <h2 className="main-slider__title">
                        {slide.title || 'MboaPass'}
                        {slide.titleAccent ? (
                          <>
                            <br /> <span>{slide.titleAccent}</span>
                          </>
                        ) : null}
                      </h2>
                      <p className="main-slider__text">
                        {slide.description || ''}
                      </p>
                      <ul className="list-unstyled main-slider__address">
                        <li>
                          <div className="icon">
                            <span className="icon-pin"></span>
                          </div>
                          <div className="text">
                            <p>{slide.location || ''}</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="icon-clock"></span>
                          </div>
                          <div className="text">
                            <p>{slide.timeLabel || ''}</p>
                          </div>
                        </li>
                      </ul>
                      <div className="main-slider__btn-box">
                        <Link to={slide.ctaLink || '/contact'} className="main-slider__btn thm-btn">
                          {slide.ctaText || 'En savoir plus'}
                          <span className="icon-arrow-right"></span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            ))}

            {/* <SwiperSlide className="swiper-slide">
              <div className="main-slider__img">
                <img src={BannerImg3} alt="" />
              </div>
              <div className="main-slider__shpae-1">
                <img src={BannerShape1} alt="" />
              </div>
              <div className="main-slider__shpae-2">
                <img src={BannerShape2} alt="" />
              </div>
              <div className="main-slider__start-1">
                <img src={BannerShape3} alt="" />
              </div>
              <div className="main-slider__start-2 zoominout">
                <img src={BannerShape4} alt="" />
              </div>
              <div className="main-slider__start-3">
                <img src={BannerShape5} alt="" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="main-slider__content">
                      <p className="main-slider__sub-title">Music Festival</p>
                      <h2 className="main-slider__title">
                        Discover a World <br /> <span>of Celebration</span>
                      </h2>
                      <p className="main-slider__text">
                        As an AI language model, I don't have personal opinions or points of view.
                        However, I <br /> can tell you that design is a multifaceted field that encompasses various elements.
                      </p>
                      <ul className="list-unstyled main-slider__address">
                        <li>
                          <div className="icon">
                            <span className="icon-pin" />
                          </div>
                          <div className="text">
                            <p>Mirpur 01 Road N 12 Dhaka Bangladesh</p>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <span className="icon-clock" />
                          </div>
                          <div className="text">
                            <p>10 Am To 10 Pm 20 April 2024</p>
                          </div>
                        </li>
                      </ul>
                      <div className="main-slider__btn-box">
                        <Link to="/contact" className="main-slider__btn thm-btn">
                          Purchase Ticket <span className="icon-arrow-right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide> */}


          </div>
        </Swiper>
        <div className="swiper-pagination" id="main-slider-pagination" />

      </section>
      {/* banner-one */}
    </>

  );
}
